import { queryOptions, useQuery } from "@tanstack/react-query";
import { type Api, listMovementPatterns } from "api-client";

export function exerciseMovementPatternsQueryOptions() {
  return queryOptions({
    queryKey: ["exercise", "movementPatterns"],
    queryFn: () => {
      return listMovementPatterns().then((res) => res.data.data);
    },
    // Movement patterns are reference data that effectively never changes.
    staleTime: Infinity,
    gcTime: Infinity,
  });
}

const EMPTY_MOVEMENT_PATTERNS: Api.ListMovementPatterns.Output.Self = [];

export function useExerciseMovementPatterns(): Api.ListMovementPatterns.Output.Self {
  const query = useQuery(exerciseMovementPatternsQueryOptions());
  return query.data ?? EMPTY_MOVEMENT_PATTERNS;
}
